customElements.define('recess-header', class RecessHeader extends HTMLElement {
  constructor() {
    super();

    // member variables
    this.message = 'Hello Vue!';
    this.isScrolled = false;
    this.activeParentLinksIndex = -1;
    this.activeChildLinksIndex = -1;
    this.activeChildLinkHoverImage = false;
    this.lightContent = false;
    this.searchFormIsActive = false;
    this.searchFormEl = false;

    // elements
    this.searchFormEl = this.querySelector('#header__search-form');
    this.cartNotificationEl = document.querySelector('cart-notification');
    this.accountEl = this.querySelector('.header-menu-right .account-link')
    this.accountBubble = this.querySelector('.account-bubble');

    // this.querySelector('#cart-icon-bubble').addEventListener('click', event => {
    //   event.preventDefault();
    //   this.cartNotificationEl.open();
    // });
    this.mobileMenuEl = this.querySelector('recess-mobile-menu');

    if (document.querySelector('[data-template-name="index"]')) {
      document.documentElement.classList.add('scroll-top');
      window.addEventListener('scroll', () => { this.handleScroll() }, false);
    }

    this.querySelectorAll('.header-menu-desktop .parent-link[data-levels="1"], .header-menu-desktop .parent-link[data-levels="2"]').forEach(el => {
      el.addEventListener('click', event => {
        event.preventDefault();
      });
    });

    this.querySelectorAll('.header-menu-desktop .parent-link[data-levels="0"], .header-menu-desktop .parent-link[data-levels="1"], .header-menu-desktop .parent-link[data-levels="2"]').forEach(el => {
      el.addEventListener('click', event => {
        const { target } = event;
        const { parentIndex } = target.dataset;

        this.activeChildLinksIndex = this.activeChildLinksIndex == parentIndex ?
          this.activeChildLinksIndex = -1 :
          this.activeChildLinksIndex = parentIndex;

        this.render();
      });
    });

    this.querySelectorAll('.header-menu-desktop--left-dropdown .grandchild-link').forEach(el => {
      el.addEventListener('mouseenter', event => {
        const { hoverImage } = event.target.dataset;

        this.activeChildLinkHoverImage = hoverImage ? hoverImage : false;

        this.render();
      });
    });

    this.querySelectorAll('.header-menu-desktop--left-dropdown .grandchild-links').forEach(el => {
      el.addEventListener('mouseleave', event => {
        this.activeChildLinkHoverImage = false;
        this.render();
      });
    });

    this.querySelectorAll('.search-link').forEach(el => {
      el.addEventListener('click', event => {
        event.preventDefault();

        this.toggleSearchForm();
      });
    });

    this.accountEl?.addEventListener('mouseenter', this.toggleAccount.bind(this));
    this.accountBubble?.addEventListener('mouseleave', this.toggleAccount.bind(this));
  }

  handleScroll() {
    return requestAnimationFrame(() => {
      if (scrollY > 0) {
        document.documentElement.classList.remove('scroll-top');
      } else {
        document.documentElement.classList.add('scroll-top');
      }
    });
  }

  toggleMC() {
    if (this.mobileMenuEl.mobileMenuIsOpen) this.mobileMenuEl.toggleMobileMenuIsOpen();

    document.documentElement.classList.remove('scroll-top');

    return this.toggleMiniCart();
  }

  toggleSearchForm() {
    if (this.searchFormIsActive) {
      this.searchFormIsActive = false;

      this.searchFormEl.reset();
    } else {
      this.searchFormIsActive = true;
      this.searchFormEl.querySelector('input[name="q"]').focus();
    }

    this.render();
  }

  toggleAccount() {
    console.log(this.accountEl);
    this.accountEl?.classList.toggle('active');
  }

  render() {
    this.querySelectorAll('.header-menu-desktop--left .parent-link-wrapper .parent-link').forEach(el => {
      el.classList.toggle('active', this.activeChildLinksIndex == el.dataset.parentIndex);
      el.setAttribute('aria-expanded', this.activeChildLinksIndex == el.dataset.parentIndex);
    });

    this.querySelector('.header__search-form').classList.toggle('active', this.searchFormIsActive);

    const childLinkMoodImage = this.querySelectorAll('.header-menu-desktop--left .parent-link-wrapper').item(this.activeChildLinksIndex).querySelector('.mood-image--child-link')

    if (this.activeChildLinkHoverImage) {
      childLinkMoodImage.setAttribute('src', this.activeChildLinkHoverImage);

      childLinkMoodImage.classList.add('active');
    } else {
      childLinkMoodImage.removeAttribute('src');
      childLinkMoodImage.classList.remove('active');
    }
  }
});
